import Footer from "../../components/main/Footer"
import { Topbar } from "../../components/organisms/Topbar"
import ApiService from "../../core/service/ApiService"
import { initPdiComponent, sendToLogServer } from "../../core/service/BusinessLogicService"
import { loc } from "../../core/utils"
import { findCurrentStepFromTunnelData } from "../../core/utils.common.js"
import { getOrderByOPL } from "../../service/OrderService"
import "./styles.css"
import React, { useEffect } from "react"
import { Col, Container, Row, Spinner } from "react-bootstrap"

const FIVE_SECONDES_INTERVAL_IN_MILLISECONDS = 5 * 1000
const WAITING_DOCUMENTS_CODE = "2"
const REJECTED_CODE = "3"
const WAIT_SIGNATURE_CODE = "21"
const DEFAULT_BPLS_TIMEOUT_MS = 60000
const parsedBplsTimeout = Number(process.env.REACT_APP_BPLS_FINANCIAL_REQUEST_TIMEOUT)
const TIMEOUT_SETTING =
  Number.isFinite(parsedBplsTimeout) && parsedBplsTimeout > 0 ? parsedBplsTimeout : DEFAULT_BPLS_TIMEOUT_MS

export default function LoaderPage({ tunnelData, history }) {
  useEffect(() => {
    initPdiComponent("LoaderPage")
    console.time("Call BPLS API Time")

    function navigateWithStep(tunnelData) {
      const tunnelDataNextStep = findCurrentStepFromTunnelData(tunnelData)
      history.push(tunnelDataNextStep.route)
    }

    const intervalId = setInterval(() => {
      getOrderByOPL(tunnelData, tunnelData.opl)
        .then(async (order) => {
          if ([WAITING_DOCUMENTS_CODE, REJECTED_CODE, WAIT_SIGNATURE_CODE].includes(order?.transactionStatus)) {
            const currentStep = findCurrentStepFromTunnelData(tunnelData)
            const newTunnelData = await ApiService.postForEvollisApi(currentStep.runUrl, {
              tunnelData: { ...tunnelData, transactionStatus: order.transactionStatus }
            })
            clearInterval(intervalId)

            console.debug("Call BPLS API end with a new status")
            console.timeEnd("Call BPLS API Time")
            sendToLogServer(
              "INFO",
              `BPLS FinancialRequest LoaderPage for OPL : [${tunnelData.opl}] with STATUS : [${JSON.stringify(
                order?.transactionStatus
              )}] => go to STEP : ${JSON.stringify(newTunnelData.tunnelData.step)}`
            )

            navigateWithStep(newTunnelData.tunnelData)
          }
        })
        .catch((err) => {
          sendToLogServer(
            "ERROR",
            `BPLS FinancialRequest LoaderPage for OPL : [${tunnelData.opl}] with Error : ${JSON.stringify(err)}`
          )
        })
    }, FIVE_SECONDES_INTERVAL_IN_MILLISECONDS)

    const timeoutId = setTimeout(() => {
      clearInterval(intervalId)
      tunnelData.step = "stepPending"

      console.debug("Call BPLS API Timeout")
      console.timeEnd("Call BPLS API Time")
      sendToLogServer(
        "INFO",
        `BPLS FinancialRequest LoaderPage TIMEOUT for OPL : [${tunnelData.opl}] go to STEP : "stepPending"`
      )
      navigateWithStep(tunnelData)
    }, TIMEOUT_SETTING)

    return function cleaningUseEffect() {
      clearInterval(intervalId)
      clearTimeout(timeoutId)
    }
  }, [TIMEOUT_SETTING, history, tunnelData])

  return (
    <Container fluid>
      <Row noGutters>
        <Col className="misc-block">
          <Row>
            <Topbar tunnelData={tunnelData} displayToggleButton={false} history={history} />
            <Col sm={12}>
              <Container>
                <Row className="justify-content-center">
                  <Col xs={10} sm={10} md={10} lg={4} className="hard-shadow-white-block misc-mono-block p-0">
                    <Col sm={12} className="rounded-sm title-band">
                      <Row className="p-4  align-items-center">
                        <h1 className="p-0 m-0 title">{loc("scoreLoaderTitle")}</h1>
                      </Row>
                    </Col>

                    <Col className="p-5 text-center">
                      <Spinner style={{color:tunnelData.brandColor}} className="spinner m-5" animation="border" role="status" />
                      <h2 className="text-bold">{loc("scoreLoaderSubtitle")}</h2>
                      <p>{loc("scoreLoaderText")}</p>
                    </Col>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Col>
        <Col sm={12}>
          <Container>
            <Footer tunnelData={tunnelData} infosAndClientPageDisplay={true} />
          </Container>
        </Col>
      </Row>
    </Container>
  )
}
